import { render, staticRenderFns } from "./u-file-input-filled-pill.vue?vue&type=template&id=5054096e&scoped=true"
import script from "./u-file-input-filled-pill.vue?vue&type=script&lang=js"
export * from "./u-file-input-filled-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054096e",
  null
  
)

export default component.exports